import React from 'react'
import { css } from '@emotion/core'
import { leaderboardFills } from '../../pages/KidsHome/BackgroundFills'
import { BackgroundFillsType } from '../../sharedPropTypes/activityProps'

const randAnime = (base = 120, multi = 50) => {
  const factor = Math.ceil(multi * Math.random())
  return {
    dur: 0.5 * base + factor,
    delay: factor,
  }
}

const landingBgCss = css`
  @keyframes drift {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(800px);
    }
  }
  position: absolute;
  width: 100%;
  height: 100%;
  g,
  svg {
    transition: opacity 0.3s ease-in-out;
  }
  path {
    transition: fill 0.3s ease-in-out;
  }
  .cloud {
    animation: drift infinite;
  }
  .cloud-1 {
    animation-delay: ${randAnime().delay}s;
    animation-duration: ${randAnime().dur}s;
  }
  .cloud-2 {
    animation-delay: ${randAnime().delay}s;
    animation-duration: ${randAnime(100).dur}s;
  }
  .cloud-3 {
    animation-delay: ${randAnime().delay}s;
    animation-duration: ${randAnime().dur}s;
  }
  .cloud-4 {
    animation-delay: ${randAnime(null, 6).delay}s;
    animation-duration: ${randAnime(150).dur}s;
  }
  .cloud-5 {
    animation-delay: ${randAnime().delay}s;
    animation-duration: ${randAnime().dur}s;
  }
  .cloud-6 {
    animation-delay: ${randAnime().delay}s;
    animation-duration: ${randAnime(200).dur}s;
  }
  .cloud-7 {
    animation-delay: ${randAnime().delay}s;
    animation-duration: ${randAnime(50).dur}s;
  }
`

export default function CloudBackground({ fillColors = leaderboardFills }) {
  return (
    <div
      css={landingBgCss}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        height: '100%',
        width: '100%',
      }}
    >
      <svg
        aria-hidden="true"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
        style={{ width: '100%', maxWidth: '100%', minWidth: '100%', height: '100%' }}
        clipPath="url(#clip1)"
      >
        <g clipPath="url(#cloudClip)" transform="translate(0,0)">
          <path
            className="cloud cloud-1"
            d="M-100,227.274c0.77,-3.509,3.09,-6.56,6.41,-8.408c3.32,-1.849,7.33,-2.326,11.05,-1.316c3.1,-7.824,12.16,-12.161,20.87,-9.994c8.71,2.168,14.19,10.122,12.62,18.33c2.62,-2.815,13.09,-2.815,13.09,6.114h-75c0,-3.571,5.85,-7.012,10.96,-4.726z"
            fill={fillColors.light05}
          />
          <path
            className="cloud cloud-2"
            d="M-100,199.121c3.478,0.002,6.694,1.743,8.459,4.576c1.473,-2.391,4.645,-3.306,7.279,-2.099c0.541,-2.527,2.179,-4.724,4.514,-6.055c2.335,-1.331,5.154,-1.674,7.77,-0.947c2.187,-5.633,8.561,-8.756,14.69,-7.195c6.128,1.56,9.982,7.287,8.88,13.197c0.6,-0.152,1.219,-0.231,1.841,-0.233c2.379,-0.004,4.612,1.084,5.991,2.917c0.447,-0.11,0.908,-0.166,1.37,-0.167c0.37,-0.001,0.739,0.034,1.101,0.104c1.278,-1.648,3.444,-2.456,5.569,-2.076c2.124,0.381,3.828,1.881,4.381,3.857h-81c1.488,-3.549,5.117,-5.879,9.155,-5.879z"
            fill={fillColors.light05}
          />
          <path
            className="cloud cloud-3"
            d="M-100,68.219c-0.615,-2.807,-2.477,-5.248,-5.132,-6.727c-2.655,-1.479,-5.86,-1.86,-8.835,-1.052c-2.486,-6.259,-9.733,-9.729,-16.701,-7.995c-6.968,1.734,-11.35,8.097,-10.097,14.664c-2.097,-2.252,-10.469,-2.252,-10.469,4.891h60c0,-2.857,-4.68,-5.61,-8.766,-3.781z"
            fill={fillColors.light02}
          />
          <path
            className="cloud cloud-4"
            d="M-100,146.121c3.478,0.002,6.694,1.743,8.459,4.576c1.473,-2.391,4.645,-3.306,7.279,-2.099c0.541,-2.527,2.179,-4.724,4.514,-6.055c2.335,-1.331,5.154,-1.674,7.77,-0.947c2.187,-5.633,8.561,-8.756,14.69,-7.195c6.128,1.56,9.982,7.287,8.88,13.197c0.6,-0.152,1.219,-0.231,1.841,-0.233c2.379,-0.004,4.612,1.084,5.991,2.917c0.447,-0.11,0.908,-0.166,1.37,-0.167c0.37,-0.001,0.739,0.034,1.101,0.104c1.278,-1.648,3.444,-2.456,5.569,-2.076c2.124,0.381,3.828,1.881,4.381,3.857h-81c1.488,-3.549,5.117,-5.879,9.155,-5.879z"
            fill={fillColors.light02}
          />
          <path
            className="cloud cloud-5"
            d="M-100,168.219c-0.615,-2.807,-2.477,-5.248,-5.132,-6.727c-2.655,-1.479,-5.86,-1.86,-8.835,-1.052c-2.486,-6.259,-9.733,-9.729,-16.701,-7.995c-6.968,1.734,-11.35,8.097,-10.097,14.664c-2.097,-2.252,-10.469,-2.252,-10.469,4.891h60c0,-2.857,-4.68,-5.61,-8.766,-3.781z"
            fill={fillColors.light02}
          />
          <path
            className="cloud cloud-6"
            d="M-100,250c3.478,0.002,6.694,1.743,8.459,4.576c1.473,-2.391,4.645,-3.306,7.279,-2.099c0.541,-2.527,2.179,-4.724,4.514,-6.055c2.335,-1.331,5.154,-1.674,7.77,-0.947c2.187,-5.633,8.561,-8.756,14.69,-7.195c6.128,1.56,9.982,7.287,8.88,13.197c0.6,-0.152,1.219,-0.231,1.841,-0.233c2.379,-0.004,4.612,1.084,5.991,2.917c0.447,-0.11,0.908,-0.166,1.37,-0.167c0.37,-0.001,0.739,0.034,1.101,0.104c1.278,-1.648,3.444,-2.456,5.569,-2.076c2.124,0.381,3.828,1.881,4.381,3.857h-81c1.488,-3.549,5.117,-5.879,9.155,-5.879z"
            fill={fillColors.light05}
          />
          <path
            className="cloud cloud-7"
            d="M-100,100c3.478,0.002,6.694,1.743,8.459,4.576c1.473,-2.391,4.645,-3.306,7.279,-2.099c0.541,-2.527,2.179,-4.724,4.514,-6.055c2.335,-1.331,5.154,-1.674,7.77,-0.947c2.187,-5.633,8.561,-8.756,14.69,-7.195c6.128,1.56,9.982,7.287,8.88,13.197c0.6,-0.152,1.219,-0.231,1.841,-0.233c2.379,-0.004,4.612,1.084,5.991,2.917c0.447,-0.11,0.908,-0.166,1.37,-0.167c0.37,-0.001,0.739,0.034,1.101,0.104c1.278,-1.648,3.444,-2.456,5.569,-2.076c2.124,0.381,3.828,1.881,4.381,3.857h-81c1.488,-3.549,5.117,-5.879,9.155,-5.879z"
            fill={fillColors.light05}
          />
        </g>
        <defs>
          <clipPath id="cloudClip">
            <rect width="100%" height="100%" fill={fillColors.base} />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

CloudBackground.propTypes = {
  fillColors: BackgroundFillsType,
}
